import {AppState} from 'redux/config'
import {createSelector} from 'reselect'

export const select_router = (state: AppState) => state.router

export const select_router_params = (state: AppState) => state.router?.last?.params

export const select_router_currentValues = (state: AppState) => ({
  params: state.router.last.params,
  name: state.router.last.currentName,
})

export const select_router_currentTransitionParams = createSelector(
  select_router_currentValues,
  currentValues => currentValues.params
)
